export function replacePath(path) {
  history.replaceState(history.state, "", path);
}
